import {
  GET_ORDER,
  GET_ORDER_ID,
  CONFIRM_ORDER,
  GET_ORDER_GSHOP,
  GET_ORDER_ID_GSHOP,
  CONFIRM_ORDER_GSHOP,
  GET_HISTORY,
  PUT_HISTORY,
  GET_VOUCHER,
  POST_VOUCHER,
  PUT_VOUCHER,
  DELETE_VOUCHER,
  SEARCH_CHECKOUT
} from '../type'

const initialState = {
  listOrder: [],
  detailOrder: null,
  countOrder: 0,
  listOrderGshop: [],
  detailOrderGshop: null,
  countOrderGshop: 0,
  listVoucher: [],
  countVoucher: 0,
  listSearchCheckout: [],
  countSearchCheckout: 0,
  listHistory: [],
  countHistory: 0
}

const order = ( state = initialState, action ) => {
  switch(action.type) {
    case GET_ORDER : 
      return {
        ...state,
        listOrder: action.data.data,
        countOrder: action.data.count,
      }
    case GET_ORDER_ID:
      return {
        ...state,
        detailOrder: action.data
      }
    case CONFIRM_ORDER : 
      return {
        ...state, 
        listOrder: state.listOrder.map(
          (item, index) => item._id === action.data._id ? state.listOrder.splice(index, 1) : item
        ),
        detailOrder: action.data
      }
    case GET_ORDER_GSHOP:
      return {
        ...state,
        listOrderGshop: action.data.data,
        countOrderGshop: action.data.count,
      }
    case GET_ORDER_ID_GSHOP:
      return {
        ...state,
        detailOrderGshop: action.data
      }
    case CONFIRM_ORDER_GSHOP:
      return {
        ...state,
        listOrderGshop: state.listOrderGshop.map(
          (item, index) => item._id === action.data._id ? state.listOrderGshop.splice(index, 1) : item
        ),
        detailOrderGshop: action.data
      }
    case GET_HISTORY:
      return {
        ...state,
        listHistory: action.data.data,
        countHistory: action.data.count
      }
    case PUT_HISTORY:
      return {
        ...state,
        listHistory: state.listHistory.map(
          (item) => item._id === action.data._id ? item = action.data : item
        )
      }
    case GET_VOUCHER : 
      return {
        ...state,
        listVoucher: action.data.data,
        countVoucher: action.data.count,
      }
    case POST_VOUCHER : 
      return {
        ...state,
        
        listVoucher: [action.data, ...state.listVoucher]
      }
    case PUT_VOUCHER:
      console.log(action.data)
      return {
        ...state,
        listVoucher: state.listVoucher.map(
          (item) => item._id === action.data._id ? item = action.data : item
        )
      }
    case DELETE_VOUCHER : 
      return {
        ...state,
        listVoucher: state.listVoucher.filter(
          (item) => item._id === action.data._id ? item = action.data : item
        )
      }
    case SEARCH_CHECKOUT:
      return {
        ...state,
        listSearchCheckout: action.data,
        countSearchCheckout: action.count
      }
    default:
      return state
  }
}

export default order